import "./base.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Models ??= {};

AppointmentBooking.Wizard.Models.MainMenuItem = class MainMenuItem extends AppointmentBooking.Wizard.Models.Base {};

AppointmentBooking.Wizard.Models.MainMenuItem.prototype.relations = [
  {
    type: Backbone.HasOne,
    key: "booking",
    relatedModel: "AppointmentBooking.Wizard.Models.Booking",
  },
];

AppointmentBooking.Wizard.Models.MainMenuItem.initializeRelations();
